import {useCallback, useEffect, useState} from 'react';

import {RESPONSE_STATUSES} from '@/src/app/constants/api';
import fetchCandidatesLocations from '@/src/jobPortal/allCandidates/utils/fetchCandidatesLocations';

const useCandidatesSearchLocationFilter = () => {
  const [candidatesLocations, setCandidatesLocations] = useState(null);

  const fetchCandidatesLocationsData = useCallback(async () => {
    const {status, responseBody} = await fetchCandidatesLocations();

    if (status === RESPONSE_STATUSES.SUCCESS) {
      setCandidatesLocations(responseBody.data);
    }
  }, []);

  useEffect(() => {
    if (candidatesLocations === null) {
      fetchCandidatesLocationsData();
    }
  }, [candidatesLocations]);

  return {
    candidatesLocations,
    isFetched: candidatesLocations === null,
  };
};

export default useCandidatesSearchLocationFilter;
